module.exports = __webpack_public_path__ + "media/images/category/feature/poj/hero_mob-e3f8628cd67c6aa030004e12de2876d2.jpg";